import { axiosBasic } from "../config/axios-common";


const getCurrentTermsDeclarations = (termCode: string) => {
    return axiosBasic.get(`/sam/v1/termsdeclarations/getCurrent/${termCode}`).then(response => {
      return response.data;
    })
    .catch(e => {
      console.log(e)
    });
};


const postInsertOrUpdateTermsDeclarations = async (data: any, professionalId: string) => {

  try {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      const response = await axiosBasic.post(`/sam/v1/termsdeclarations/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

      const responseData = await response.data;

      return responseData;

  } catch (e: any) {
      throw e;
  }
};


const exportedObject = {
    getCurrentTermsDeclarations,
    postInsertOrUpdateTermsDeclarations
  };
  
  
  export default exportedObject
  